"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
var react_1 = __importDefault(require("react"));
var ShoppingCart_1 = __importDefault(require("@mui/icons-material/ShoppingCart"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var ButtonGroup_1 = __importDefault(require("@mui/material/ButtonGroup"));
var AppBar_1 = __importDefault(require("@mui/material/AppBar"));
var Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
var styled_1 = __importDefault(require("@emotion/styled"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var Badge_1 = __importDefault(require("@mui/material/Badge"));
var Avatar_1 = __importDefault(require("@mui/material/Avatar"));
var system_1 = require("@mui/system");
var Notifications_1 = __importDefault(require("@mui/icons-material/Notifications"));
var Chat_1 = __importDefault(require("@mui/icons-material/Chat"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
require("../assets/styles/navbar.css");
var js_cookie_1 = __importDefault(require("js-cookie"));
var SearchProduct_1 = __importDefault(require("./SearchProduct"));
var react_router_dom_1 = require("react-router-dom");
var useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
var styles_1 = require("@mui/material/styles");
var Notification_1 = __importDefault(require("./Notification"));
var material_1 = require("@mui/material");
var icons_material_1 = require("@mui/icons-material");
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var StyledToolbar = (0, styled_1.default)(Toolbar_1.default)({
    display: "flex",
    justifyContent: "space-between",
});
function NavbarTop() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    function getCookie(name) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        var gettoken = js_cookie_1.default.get(name);
        return gettoken;
    }
    var _a = react_1.default.useState(false), open = _a[0], setOpen = _a[1];
    var theme = (0, styles_1.useTheme)();
    var fullScreen = (0, useMediaQuery_1.default)(theme.breakpoints.down("md"));
    var handleClickOpen = function () {
        setOpen(true);
    };
    var handleClose = function () {
        setOpen(false);
    };
    var token = getCookie("token");
    function Logout() {
        js_cookie_1.default.remove("token");
        js_cookie_1.default.remove("role");
        navigate("/");
    }
    var role = localStorage.getItem("role");
    var _b = react_1.default.useState(false), openSnackbar = _b[0], setOpenSnackbar = _b[1];
    var _c = react_1.default.useState(null), errorMessage = _c[0], setErrorMessage = _c[1];
    var handleDisplayError = function (message) {
        setErrorMessage(message);
        setOpenSnackbar(true);
    };
    var handleLinkClick = function () {
        if (!role) {
            handleDisplayError("You have to log in first");
        }
    };
    var handleCloseSnackbar = function () {
        setOpenSnackbar(false);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(AppBar_1.default, { position: "sticky", color: "secondary" },
            react_1.default.createElement(material_1.Snackbar, { open: openSnackbar, 
                // autoHideDuration={2000}
                onClose: handleCloseSnackbar, disableWindowBlurListener: true, anchorOrigin: { vertical: "top", horizontal: "right" } },
                react_1.default.createElement(material_1.SnackbarContent, { sx: { backgroundColor: "red" }, message: errorMessage, action: [
                        react_1.default.createElement(IconButton_1.default, { key: "close", size: "small", color: "inherit", onClick: handleCloseSnackbar },
                            react_1.default.createElement(Close_1.default, null)),
                    ] })),
            react_1.default.createElement(StyledToolbar, null,
                react_1.default.createElement(Typography_1.default, { variant: "h6" },
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/", className: "linkers" }, "!SHOP")),
                react_1.default.createElement(SearchProduct_1.default, null),
                react_1.default.createElement(system_1.Stack, { direction: "row", gap: "20px" },
                    react_1.default.createElement(IconButton_1.default, { "aria-label": "cart", component: react_router_dom_1.Link, to: "/cart" },
                        react_1.default.createElement(Badge_1.default, { badgeContent: 0, color: "error" },
                            react_1.default.createElement(ShoppingCart_1.default, { color: "primary" }))),
                    react_1.default.createElement(material_1.Tooltip, { title: "Notifications" },
                        react_1.default.createElement(IconButton_1.default, { "aria-label": "notification", onClick: handleClickOpen },
                            react_1.default.createElement(Badge_1.default, { badgeContent: 0, color: "error" },
                                react_1.default.createElement(Notifications_1.default, { color: "primary" })))),
                    react_1.default.createElement(IconButton_1.default, { "aria-label": "chat", href: "/chat" },
                        react_1.default.createElement(Badge_1.default, { badgeContent: 0, color: "error" },
                            react_1.default.createElement(Chat_1.default, { color: "primary" })))),
                react_1.default.createElement(system_1.Stack, { direction: "row", gap: "20px" },
                    react_1.default.createElement(react_router_dom_1.Link, { to: role === "seller"
                            ? "/seller-home"
                            : role === "admin"
                                ? "/admin-dashboard"
                                : role === "user"
                                    ? "/profile"
                                    : "", onClick: handleLinkClick },
                        react_1.default.createElement(Avatar_1.default, null)),
                    token ? (react_1.default.createElement(Button_1.default, { size: "small", variant: "text", color: "primary", onClick: Logout }, "Logout")) : (react_1.default.createElement(ButtonGroup_1.default, { size: "small", variant: "text", color: "primary" },
                        react_1.default.createElement(Button_1.default, { component: react_router_dom_1.Link, to: "/login" }, "login"),
                        react_1.default.createElement(Button_1.default, { component: react_router_dom_1.Link, to: "/signup" }, "Register")))))),
        react_1.default.createElement(material_1.Dialog, { fullScreen: fullScreen, open: open, onClose: handleClose, "aria-labelledby": "responsive-dialog-title" },
            react_1.default.createElement(material_1.Box, { sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                } },
                react_1.default.createElement(material_1.DialogTitle, { id: "responsive-dialog-title" }, "Notifications"),
                react_1.default.createElement(icons_material_1.CloseRounded, { sx: { mr: 5, cursor: "pointer" }, onClick: handleClose })),
            react_1.default.createElement(material_1.DialogContent, null,
                react_1.default.createElement(Notification_1.default, null)),
            react_1.default.createElement(material_1.Divider, null),
            react_1.default.createElement(Typography_1.default, { gutterBottom: true, sx: { ml: 3, textDecoration: "none" }, component: react_router_dom_1.Link, to: "/notifications", color: "info" }, "View all notifications"))));
}
exports.default = NavbarTop;
